// hudController.js — Space Supremacy · TAP-ARENA HUD logic.
// Skill-cooldown tracking + floating hit-number palette. The active skill roster
// is built in StageOneTrek from the deployed squad's profile skill trees.

export const FLOAT_COLORS = {
  damage: "#ff3333", // damage taken
  heal: "#33ff33",   // healing ticks
  crit: "#ffd23f",   // critical strike
  info: "#7fd8ff",
};

// Lightweight cooldown tracker (wall-clock based, tamper-agnostic for a solo PvE run).
export class Cooldowns {
  constructor() { this.until = {}; }
  ready(id) { return (this.until[id] || 0) <= performance.now(); }
  remaining(id) { return Math.max(0, (this.until[id] || 0) - performance.now()); }
  fraction(id, cd) {
    const rem = this.remaining(id);
    return cd > 0 ? rem / cd : 0;
  }
  trigger(id, cd) { this.until[id] = performance.now() + cd; }
  reset() { this.until = {}; }
}
